import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import "./src/styles/_global.css"

import React from "react"

import { RecombeeContextProvider } from "./src/contexts/RecombeeContext"

export const wrapRootElement = ({ element }) => (
  <RecombeeContextProvider>{element}</RecombeeContextProvider>
)

/* exports.onRouteUpdate = ({ location }, options) => {
  if (typeof Analytics !== "undefined") {
    if (options && options.debug) {
      console.log("analytics.page() called")
    }
    // On every route change fire this code!!
    Analytics.page()
  }
} */

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.state && location.state.preventScroll === true) {
    return false
  }

  if (location.hash) {
    window.history.scrollRestoration = "auto"
    return true
  }

  window.history.scrollRestoration = "manual"

  const currentPosition = getSavedScrollPosition(location, location.key)
  const top = currentPosition ? currentPosition[1] : 0

  window.setTimeout(() => {
    window.requestAnimationFrame(() => {
      try {
        window.scrollTo({ top, behavior: "instant" })
      } catch (e) {
        window.scrollTo(top)
      }
    })
  }, 0)

  return false
}
